var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-image"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"width":_vm.width,"height":_vm.height,"id":_vm.id}}):_c('i',{staticClass:"empty-image far fa-image"})])}
var staticRenderFns = []

export { render, staticRenderFns }